export class PropertyService {
    // 表示範囲内の物件データを取得
    static async fetchPropertiesInBounds(
        type = "all",
        latFrom,
        latTo,
        lngFrom,
        lngTo
    ) {
        const params = new URLSearchParams({
            latFrom,
            latTo,
            lngFrom,
            lngTo,
        });
        try {
            const response = await fetch(
                `/api/search/map/type/${type}?${params.toString()}`
            );
            if (!response.ok) throw new Error(`APIエラー: ${response.status}`);
            const data = await response.json();
            return data.items;
        } catch (error) {
            console.error("APIエラー:", error);
            throw error;
        }
    }

    // idsによって物件を取得
    static async fetchPropertiesByIds(ids, type = "buy") {
        const params = new URLSearchParams();
        ids.forEach((id) => params.append("id[]", id));

        try {
            const response = await fetch(
                `/api/search/map-cards/id?${params.toString()}&type=${type}`
            );

            if (!response.ok) throw new Error(`APIエラー: ${response.status}`);
            return await response.text();
        } catch (error) {
            console.error("APIエラー:", error);
            throw error;
        }
    }
}

export default PropertyService;
